import * as React from "react";
import { Collapse } from "../../collapse/collapse/collapse.mjs";
class CollapseLayer extends React.Component {
  BEM() {
    const classArray = ["collapse-layer"];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  render() {
    return /* @__PURE__ */ React.createElement(Collapse, { ...this.props, className: this.BEM() });
  }
}
export {
  CollapseLayer
};
